import { graphql } from '../graphql';

export const myReferralsQuery = graphql(`
  query MyReferrals {
    myReferrals {
      id
      referredEmail
      token
      accountCreatedAt
      organizationCreatedAt
      subscriptionStartedAt
      expiresAt
      createdAt
      referredUser {
        firstName
        lastName
        name
      }
      organization {
        id
        name
        slug
      }
    }
  }
`);
